import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import api from "Service/api/api";
import {
  IReducerWithCallbackWithError,
  IUpdateReducerWithCallback,
} from "Shared/Types/shared";
import { IWarrantyFilterParams } from "Shared/Types/warranty";
import { IAddFilesToEntityTypes } from "Shared/Types/file";

export const getWarranty = createAsyncThunk(
  "warranty/getWarranty",
  async (id: string) => {
    try {
      const response = await api.warranty.getWarrantyById(id);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const getWarrantyList = createAsyncThunk(
  "warranty/getWarrantyList",
  async (params: IWarrantyFilterParams | null = null) => {
    try {
      const response = await api.warranty.getWarrantyList(params);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const deleteWarranty = createAsyncThunk(
  "warranty/deleteWarranty",
  async (id: string) => {
    try {
      const response = await api.warranty.deleteWarranty(id);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);
export const addWarranty = createAsyncThunk(
  "warranty/addWarranty",
  async ({ data, onSuccess, onError }: IReducerWithCallbackWithError<any>) => {
    try {
      const response = await api.warranty.addWarranty(data);
      onSuccess?.(response.data);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError && error.response) {
        onError?.(error);
      }
      throw error;
    }
  }
);

export const updateWarranty = createAsyncThunk(
  "warranty/updateWarranty",
  async ({ id, data, onError, onSuccess }: IUpdateReducerWithCallback<any>) => {
    try {
      const response = await api.warranty.updateWarranty(id, data);
      onSuccess?.();
      return response.data;
    } catch (error) {
      onError?.();
      console.error(error);
      throw error;
    }
  }
);

const getCurrentWarranty = createAsyncThunk(
  "warranties/getCurrentWarranty",
  async (id: string) => {
    try {
      const response = await api.warranty.getWarrantyById(id);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const addAttachmentsToWarranties = createAsyncThunk(
  "warranties/addAttachmentsToWarranties",
  async (
    {
      id,
      files,
      onErrorUploadFiles,
      onSuccessUploadFiles,
    }: IAddFilesToEntityTypes,
    { dispatch }
  ) => {
    try {
      await api.warranty.addAttachmentsToWarranty({ id, files });
      onSuccessUploadFiles?.();
      dispatch(getCurrentWarranty(id));
    } catch (error) {
      onErrorUploadFiles?.();
      console.error(error);
      throw error;
    }
  }
);

export const deleteAttachmentsFromWarranties = createAsyncThunk(
  "warranties/deleteAttachmentsFromWarranties",
  async (
    {
      id,
      files,
      onErrorUploadFiles,
      onSuccessUploadFiles,
    }: IAddFilesToEntityTypes,
    { dispatch }
  ) => {
    try {
      await api.warranty.deleteAttachmentsFromWarranty({ id, files });
      onSuccessUploadFiles?.();
      dispatch(getCurrentWarranty(id));
    } catch (error) {
      onErrorUploadFiles?.();
      console.error(error);
      throw error;
    }
  }
);
